<template>
  <v-toolbar
      class="navigation"
      :color="color"
      :elevation="isLandingPage ? 0 : 2"
      :style="{
        width,
        padding: width === '100%' ? $vuetify.breakpoint.xs ? '0' : '0 4em' : ''
      }"
  >
    <div class="d-flex flex-row justify-space-between align-center nav-content ma-0 px-2 py-0">
      <div v-if="!(isLandingPage || hasLogo)" class="d-flex flex-row">
        <v-icon class="mr-2" v-if="!showSearch || !searchString" @click.stop="showSearch = !showSearch">mdi-magnify</v-icon>
        <v-text-field
            v-if="showSearch"
            v-model.lazy="searchString"
            background-color="#f5f6f8"
            class="shrink hidden-sm-and-down"
            dense
            flat
            hide-details
            rounded
            @keydown.enter="search(searchString)"
            @input="debounceSearch(searchString)"
            solo
            clearable
        >
          <template v-if="!searchString" v-slot:label>
            <v-icon class="mr-2">mdi-magnify</v-icon>
            search a blog
          </template>
        </v-text-field>
      </div>
      <router-link to="/" v-if="isLandingPage || hasLogo">
        <img :src="logo" alt="company logo" class="logo" />
      </router-link>
      <v-spacer/>
      <v-list-item-group active-class="active-item"  class="d-flex flex-row pa-0 ma-0">
        <v-list-item class="mb-0 px-8" link to="/home">
          <v-list-item-title> Blogs</v-list-item-title>
        </v-list-item>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on" class="mb-0 px-8 ml-2">
              <v-list-item-title>Learning</v-list-item-title>
            </v-list-item>
          </template>
          <v-list>
            <v-list-item v-for="(item,index) in learningLinks" :key="index" link :to="item.link">
              <v-list-item-title >{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item-group>
      <v-spacer/>
      <div>
        <v-icon v-if="showUploadVideoButton" @click="showUploadFilesDialog()" class="ma-2">
          mdi-plus
        </v-icon>
        <template v-if="!isAuthenticated">
          <v-btn v-if="!isLoginPage" :to="`/login?from=${currentRoute}`" elevation="0" class="mr-2">
            Login
          </v-btn>
          <v-btn v-if="!isSignInPage" :to="`/signup?from=${currentRoute}`" elevation="0" color="primary">
            Signup
          </v-btn>
        </template>
        <v-menu v-else bottom min-width="200px" offset-y rounded>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon x-large>
              <Avatar :canRouteToProfile="false" :user="user" size="35"/>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-center">
              <div class="mx-auto text-center">
                <Avatar :canRouteToProfile="false" :user="user" size="30"/>
                <h3 class="mt-2">{{ fullName }}</h3>
                <v-divider class="my-3" v-if="user.uuid"></v-divider>
                <a
                    v-if="isMentor && user.uuid"
                    class="text-decoration-none text-body-2 text-no-wrap"
                    @click.prevent="$router.push(`/mentors/${user.uuid}`)"
                >
                  My Public Profile
                </a>
                <v-divider class="my-3"></v-divider>
                <v-btn elevation="0" depressed rounded text to="/profile/"> Edit Account</v-btn>
                <v-divider class="my-3"></v-divider>
                <v-btn depressed rounded text @click="handleLogout()">
                  Logout
                </v-btn>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
      </div>
    </div>
    <LogoutDialog :reveal="showLogOutDialog" @cancel="showLogOutDialog = false" @logOutSuccess="showLogOutDialog = false" />
    <UploadDialog
        :dialog="showUploadDialog"
        :field-name="'Upload video'"
        expectedFileFormats="MP4, AVI, MKV"
        :acceptedFileTypes="'video/*'"
        @onFilesUploaded="handleFilesUploaded($event)"
        @onClose="showUploadDialog = false"
    />
  </v-toolbar>
</template>
<script>
import logo from "@/assets/logo-blue.svg";
import book from "@/assets/book.png";
import navigate from "@/assets/navigate.png";
import {mapGetters, mapMutations} from "vuex";
import Avatar from "./Avatar";
import countries from '@/constants/countries.json';
import LogoutDialog from '@/components/LogOutDialog.vue'
import UploadDialog from "@/components/UploadDialog.vue";
export default {
  components: {Avatar, LogoutDialog, UploadDialog},
  props: {
    width: {
      type: String,
      default: '100%'
    },
    color: {
      type: String,
      default: 'white'
    },
    isLandingPage: {
      type: Boolean,
      default: false
    },
    hasLogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logo,
      countries,
      selectedCountry: 'UG',
      book,
      navigate,
      drawer: true,
      searchString: "",
      showSearch: false,
      showLogOutDialog: false,
      image: "https://firebasestorage.googleapis.com/v0/b/guio-web.appspot.com/o/blank-profile-picture-973460_1280.png?alt=media&token=8d628e4e-925a-499d-a839-d9a81f59654e",
      showUploadDialog: false,
      learningLinks: [
        { title: 'Tutors',link:"/tutors" },
        { title: 'Question Material/Past papers',link:"/questions" },
      ]
    };
  },
  mounted(){
    if(process.env.VUE_APP_ENVIRONMENT !== 'production') {
      this.learningLinks = [...this.learningLinks,
       { title: 'Learning materials',link:"/learning" }]
    }
    this.searchString = this.$route?.query?.q || ""
    if(this.user?.profile?.country) {
      this.selectedCountry = this.user?.profile?.country;
    }
  },
  methods: {
    ...mapMutations({
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",

    }),
    ...mapMutations({
      logOut: "auth/SET_AUTH_LOGOUT",
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",
      setProfile: "auth/SET_USER_PROFILE"
    }),
    onClickAppBarIcon() {
      this.$emit("onClickAppBarIcon");
    },
    async handleLogout() {
      this.showLogOutDialog = true;
    },
    debounceSearch(searchString){
      clearTimeout(this._timerId)
      this._timerId = setTimeout(()=> {this.search(searchString)},1100)
    },
    search(searchString){
      if(searchString.trim()?.length){
        this.$router.push({path: `/blogs/search?q=${searchString.trim()}`}).catch(()=>{})
      }else{
        this.$router.push({path: `/blogs/search`}).catch(()=>{})
      }
    },
    showUploadFilesDialog() {
      this.showUploadDialog = true
    },
    handleFilesUploaded(res) {
      this.setAuthSuccess({...this.user, profile: {...this.user.profile, ...res}});
      this.setProfile({...this.profile, ...res});
    },
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    fullName() {
      return this.user.first_name && this.user.last_name
          ? `${this.user.first_name} ${this.user.last_name}`
          : this.user.username;
    },
    currentRoute() {
      return this.$router?.currentRoute?.path;
    },
    isMentor() {
      return this.user.account_types?.filter((item) => item.name === "MENTOR").length;
    },
    isLoginPage() {
      return this.$route.path.indexOf("login") !== -1;
    },
    isSignInPage() {
      return this.$route.path.indexOf("signup") !== -1;
    },
    showCreateButton() {
      const path = this.$route.path
      const blogRoute = path === `/blogs/new/create`
      return this.user?.account_types?.filter(item => item.name === "MENTOR").length && (!blogRoute && this.$route.path.includes('blogs'))
    },
    showUploadVideoButton() {
      const hasNoVideo = this.user.profile?.video_mentors?.length;
      return this.user?.account_types?.filter(item => item.name === "MENTOR").length && !hasNoVideo
    },
  },
};
</script>

<style scoped>
.nav-content {
  width: 100%;
}

.logo {
  width: 45px;
  height: 45px;
}

.company-name {
  font-size: 1em;
  font-family: Montserrat;
  font-weight: 800;
}

.gui-o {
  color: #0033AA;
}

.v-text-field {
  width: 300px;
}

.active-item {
  border-bottom: 0.15em solid #0033AA;
  border-radius: unset;
}

.active-item-sm {
  border-right: 0.3em solid #0033AA;
  border-radius: unset;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  background-color: white !important;
}

.chat-icon,
.notification-icon {
  cursor: pointer;
}
.navigation {
  box-shadow: 0 42px 100px rgba(0, 0, 0, 0.12);
  position: fixed;
  z-index: 2;
}
</style>
